import { useState } from "react";
import { useDispatch } from "react-redux";

import actions from "@/actions";
import { Mark } from "@/sx-layout/models";

export const useCopyMarkModal = (): {
  markId: number | null;
  open: (mark: Mark) => void;
  close: () => void;
  copyMark: (from: string, to: string, option?: { onSuccess: () => void }) => void;
} => {
  const dispatch = useDispatch();
  const [markId, setMarkId] = useState<number>();

  const open = (mark: Mark) => {
    setMarkId(mark.mark_id);
  };

  const close = () => {
    setMarkId(null);
  };

  const copyMark = (layoutDateFrom: string, layoutDateTo: string, option?: { onSuccess: () => void }) => {
    dispatch(
      actions.mark.copyMark(
        {
          mark_id: markId,
          layout_date_from: layoutDateFrom,
          layout_date_to: layoutDateTo,
        },
        () => {
          close();
          option?.onSuccess?.();
        }
      )
    );
  };

  return {
    markId,
    open,
    close,
    copyMark,
  };
};
